<p-toast />
<mat-menu #menu="matMenu" style="position: absolute; bottom: 10px; right: 10px; z-index: 9999">
    <button *ngFor="let item of list_menu" (click)="operaciones_menu(item.text,$event)" [disabled]="!modovisualizar"
        class="items_menu">
        <div>
            <mat-icon>{{ item.icon }}</mat-icon>
        </div>
        <div>
            <span>{{ item.text }}</span>
        </div>
    </button>
</mat-menu>

<p-toast key="tl" appendTo="body" position="bottom-right"></p-toast>
<p-confirmdialog key="C" />

@if(from_operaciones && initBtnsSuperiores){
<app-ov-funciones-botones-superior #tabBotonesSuperiores [oRow]="initBtnsSuperiores"
    (onDocumentadaFn)="onDocumentada($event)" (onDocEnd)="onDocumentadaEnd()"
    [listados]="maestrosBtnsSupSubject$ | async">
</app-ov-funciones-botones-superior>
}

<p-accordion [multiple]="true">
    <p-accordionTab header="Datos Generales">

        <form [formGroup]="group_datosgenerales">
            <div class="a-example-full-width-alterno-content-column-2">
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <!-- <input inputId="on_label" [ngClass]="{ readonly: readOnlyNumeroDGDG }" pInputText
                                    formControlName="numero" appendTo="body" class="w-full md:w-56"
                                    pSize="small" /> -->
                                <!--id="username"-->
                                <input inputId="on_label" pInputText formControlName="numero" appendTo="body"
                                    class="w-full md:w-56" pSize="small" [readonly]="readOnlyNumeroDGDG"
                                    [ngClass]="{ readonly: readOnlyNumeroDGDG }" [style.user-select]="'text'"
                                    [style.pointer-events]="'auto'"
                                    [style.background-color]="readOnlyNumeroDGDG ? '#f5f5f5' : null"
                                    [style.cursor]="readOnlyNumeroDGDG ? 'default' : null" />

                                <label for="on_label">Número</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <!-- <input inputId="on_label" [ngClass]="{ readonly: readOnlyNumeroCotizacionDG }"
                                    pInputText formControlName="numerocotizacion" appendTo="body" class="w-full md:w-56"
                                    pSize="small" /> -->
                                <input inputId="on_label" pInputText formControlName="numerocotizacion" appendTo="body"
                                    class="w-full md:w-56" pSize="small" [readonly]="readOnlyNumeroCotizacionDG"
                                    [ngClass]="{ readonly: readOnlyNumeroCotizacionDG }" [style.user-select]="'text'"
                                    [style.pointer-events]="'auto'"
                                    [style.background-color]="readOnlyNumeroCotizacionDG ? '#f5f5f5' : null"
                                    [style.cursor]="readOnlyNumeroCotizacionDG ? 'default' : null" />

                                <label *ngIf="group_datosgenerales.get('numerocotizacion')?.value" for="on_label">
                                    Número Cotización</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('estado')?.invalid && (this.group_datosgenerales.get('estado')?.touched),  readonly: readOnlyEstadoDG }"
                                    [options]="ListaTodosEstado" placeholder="‎ " optionLabel="nombre"
                                    formControlName="estado" optionValue="codigo" appendTo="body"
                                    styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Estado</label>
                                <small
                                    *ngIf="this.group_datosgenerales.get('estado')?.invalid && (this.group_datosgenerales.get('estado')?.touched)"
                                    class="text-red-500">
                                    Este campo es obligatorio
                                </small>
                            </p-floatlabel>
                        </div>
                    </div>
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-0_2">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readonlyOrdenCompraDG }" pInputText
                                    formControlName="ordencompra" appendTo="body" class="w-full md:w-56"
                                    pSize="small" />
                                <label for="on_label">Orden Compra</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-0_2">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('regimen')?.invalid && (this.group_datosgenerales.get('regimen')?.touched), readonly: readonlyRegimenDG }"
                                    [options]="ListaTodosRegimen" placeholder="‎ " optionLabel="nombre"
                                    formControlName="regimen" optionValue="codigo" (onChange)="onRegimenChange($event)"
                                    appendTo="body" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Regimen</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('regimen')?.invalid && (this.group_datosgenerales.get('regimen')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label"
                                [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('agente')?.invalid && (this.group_datosgenerales.get('agente')?.touched), readonly: readOnlyAgenteDG }"
                                [options]="ListaTodosAgentes" placeholder="‎ " optionLabel="nombre"
                                formControlName="agente" optionValue="nombre" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" (onChange)="onAgenteChange($event)"
                                size="small">
                            </p-select>
                            <label for="on_label">Agente</label>
                        </p-floatlabel>
                        <small
                            *ngIf="this.group_datosgenerales.get('agente')?.invalid && (this.group_datosgenerales.get('agente')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">

                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('via')?.invalid && (this.group_datosgenerales.get('via')?.touched), readonly: readonlyViaDG }"
                                    [options]="ListaTodosVia" placeholder="‎ " optionLabel="nombre"
                                    formControlName="via" optionValue="codigo" (onChange)="onViaChange($event)"
                                    appendTo="body" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Via</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('via')?.invalid && (this.group_datosgenerales.get('via')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('lineanegocio')?.invalid && (this.group_datosgenerales.get('lineanegocio')?.touched), readonly: readonlyLineaNegocioDG }"
                                    [options]="ListaTodosLineaNegocio" placeholder="‎ " optionLabel="nombre"
                                    formControlName="lineanegocio" (onChange)="onLineaNegocioChange($event)"
                                    optionValue="codigo" appendTo="body" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Linea negocio</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('lineanegocio')?.invalid && (this.group_datosgenerales.get('lineanegocio')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel " variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{ 'ng-invalid ng-dirty': this.group_datosgenerales.get('fechaemision')?.invalid && (this.group_datosgenerales.get('fechaemision')?.touched), readonly: readonlyFEmisionDG }"
                                    formControlName="fechaemision" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                    dateFormat="dd/mm/yy" (onChange)="onFechaEmiChange($event)" [showOnFocus]="false"
                                    [readonlyInput]="false" (onInput)="formatDateInput($event)" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Emision</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('fechaemision')?.invalid && (this.group_datosgenerales.get('fechaemision')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2">
                        <div class="w-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('cliente')?.invalid && (this.group_datosgenerales.get('cliente')?.touched), readonly: readOnlyClienteDG }"
                                    [options]="ListaTodosCliente" placeholder="‎ " optionLabel="nombre"
                                    formControlName="cliente" optionValue="nombre" appendTo="body" [filter]="true"
                                    [showClear]="true" styleClass="w-full md:w-56" (onChange)="onClienteChange($event)"
                                    (onClear)="onClienteClear()" virtualScroll="true" size="small">
                                </p-select>
                                <label for="on_label">Cliente</label>
                            </p-floatlabel>
                            <p-button icon="pi pi-replay" size="small" variant="outlined"
                                (onClick)="actualizarListaEntidad(1,this.ListaTodosCliente,'Cliente')"
                                styleClass="h-full"></p-button>
                        </div>
                        <small
                            *ngIf="this.group_datosgenerales.get('cliente')?.invalid && (this.group_datosgenerales.get('cliente')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                        @if(solo_aereo == false){
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{ 'ng-invalid ng-dirty': this.group_datosgenerales.get('fechavencimiento')?.invalid && (this.group_datosgenerales.get('fechavencimiento')?.touched), readonly: readonlyFVencimientoDG }"
                                    formControlName="fechavencimiento" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" styleClass="w-full md:w-56"
                                    dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                                    (onInput)="formatDateInput($event)" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Vencimiento</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('fechavencimiento')?.invalid && (this.group_datosgenerales.get('fechavencimiento')?.touched),"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('fechaaprobacion')?.invalid && (this.group_datosgenerales.get('fechaaprobacion')?.touched), readonly: readonlyFAprobacionDG }"
                                    formControlName="fechaaprobacion" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    styleClass="w-full md:w-56" [readonlyInput]="false"
                                    (onInput)="formatDateInput($event)" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Aprobacion</label>
                            </p-floatlabel>
                        </div>
                        }
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('fechaembarque')?.invalid && (this.group_datosgenerales.get('fechaembarque')?.touched), readonly: readonlyFEmbarqueDG }"
                                    formControlName="fechaembarque" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    [readonlyInput]="true" [disabled]="true" (onInput)="formatDateInput($event)"
                                    styleClass="w-full md:w-56" size="small">
                                </p-datepicker>
                                <label for="on_label">{{ fechaEm_z }}</label>
                            </p-floatlabel>
                        </div>
                        @if(solo_aereo == true && from_operaciones == true){
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('fecsalida')?.invalid && (this.group_datosgenerales.get('fecsalida')?.touched), readonly: readonlyRegimenDG }"
                                    formControlName="fecsalida" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    styleClass="w-full md:w-56" [readonlyInput]="false"
                                    (onInput)="formatDateInput($event)" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Salida</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('feconexion')?.invalid && (this.group_datosgenerales.get('feconexion')?.touched), readonly: readonlyRegimenDG }"
                                    formControlName="feconexion" appendTo="body" [iconDisplay]="'input'"
                                    [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    styleClass="w-full md:w-56" [readonlyInput]="false"
                                    (onInput)="formatDateInput($event)" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Conexión</label>
                            </p-floatlabel>
                        </div>
                        }
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-0_4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('customer')?.invalid && (this.group_datosgenerales.get('customer')?.touched), readonly: readOnlyCustomerDG }"
                                    [options]="ListaTodosCustomer" placeholder="‎ " optionLabel="nombre"
                                    formControlName="customer" optionValue="nombre" appendTo="body" [filter]="true"
                                    [showClear]="true" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Customer</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('customer')?.invalid && (this.group_datosgenerales.get('customer')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                        <div class="a-example-full-width-alterno-content-4">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label" [ngClass]="{ readonly: readonlyIncotermDG }"
                                    [options]="ListaTodosIncoterm" placeholder="‎ " optionLabel="nombre"
                                    formControlName="incoterm" optionValue="codigo" appendTo="body"
                                    styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Incoterm</label>
                            </p-floatlabel>
                            <!-- <small
                                *ngIf="this.group_datosgenerales.get('incoterm')?.invalid && (this.group_datosgenerales.get('incoterm')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small> -->
                        </div>
                    </div>
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-0_2">
                            <p-floatlabel class="w-full md:w-full bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_datosgenerales.get('ejecutivo')?.invalid && (this.group_datosgenerales.get('ejecutivo')?.touched), readonly: readOnlyEjecutivoDG }"
                                    [options]="ListaTodosEjecutivos" placeholder="‎ " optionLabel="nombre"
                                    formControlName="ejecutivo" optionValue="nombre" appendTo="body" [filter]="true"
                                    [showClear]="true" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Ejecutivo</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_datosgenerales.get('ejecutivo')?.invalid && (this.group_datosgenerales.get('ejecutivo')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>
                        <div class="a-checkbox a-example-full-width-alterno-content-4 bold-floatlabel"
                            style="align-items: center;">
                            <p-checkbox [ngClass]="{ readonly: readonlyAvisoLl_zDG }" formControlName="avisodellegada"
                                [binary]="true" inputId="binary" appendTo="body" size="small">
                            </p-checkbox>
                            <label>{{ avisoLl_z }}</label>
                        </div>

                        @if(solo_aereo == false){
                        <div class="a-checkbox a-example-full-width-alterno-content-4">
                            <p-checkbox [ngClass]="{ readonly: readonlyCotPropiaDG }" formControlName="cotizacionpropia"
                                [binary]="true" inputId="binary" appendTo="body" size="small">
                            </p-checkbox>
                            <label>Cotización Propia</label>
                        </div>
                        }
                    </div>
                </div>
                <!-- <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row"> -->
                <!-- <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row-2">
                            <div class="a-checkbox a-example-full-width-alterno-content-2">
                                <p-checkbox [ngClass]="{ readonly: readonlyServLogisticoDG }"
                                    formControlName="serviciologistico" [binary]="true" inputId="binary"
                                    appendTo="body">
                                </p-checkbox>
                                <label>Servicio Logistico</label>
                            </div>
                            <div class="a-checkbox a-example-full-width-alterno-content-2">
                                <p-checkbox [ngClass]="{ readonly: readonlyServicioDG }" formControlName="servicio"
                                    [binary]="true" inputId="binary" appendTo="body">
                                </p-checkbox>
                                <label>Servicio</label>
                            </div>
                        </div> -->
                <!-- <div class="a-example-full-width-alterno-content-2 a-example-full-width-alterno-content-row-2"> -->
                <!-- <div class="a-checkbox a-example-full-width-alterno-content-2">
                                <p-checkbox [ngClass]="{ readonly: readonlyCotPropiaDG }"
                                    formControlName="cotizacionpropia" [binary]="true" inputId="binary" appendTo="body">
                                </p-checkbox>
                                <label>Cotización Propia</label>
                            </div> -->

                <!-- </div>
                    </div>
                </div> -->
            </div>
        </form>

    </p-accordionTab>

    <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------------ -->
    <!--                                                               SERVICIOS Y TARIFAS                                                                            -->
    <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------------ -->

    <p-accordionTab header="Servicios Y Tarifa">

        <form [formGroup]="group_serviciostarifa" class="a-example-full-width-alterno-content-column-2">
            <p-confirmdialog key="T" />
            <div class="titulo_secciones">Datos de contrato</div>
            <div class="a-example-full-width-alterno-content-column-2">
                @if(solo_aereo == true && from_operaciones == true){
                <div class="a-example-full-width-alterno-content-row">

                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyTransportisaSTST }"
                                [options]="ListaTodosTransportista" placeholder="‎" optionLabel="nombre"
                                formControlName="transportista" optionValue="nombre" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" (onChange)="onTransporteChange($event)"
                                size="small">
                            </p-select>
                            <label for="on_label">Línea Aérea</label>
                        </p-floatlabel>
                    </div>

                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyTransportisaSTST }"
                                [options]="ListaTodosTransportista" placeholder="‎" optionLabel="nombre"
                                formControlName="aerolinea" optionValue="codigo" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Aerolínea</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">

                    <div class="a-example-full-width-alterno-content-3">
                        <div class="-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('puertoorigen')?.invalid && (this.group_serviciostarifa.get('puertoorigen')?.touched), readonly: readonlyPuertoOrigenST }"
                                    [options]="ListaFiltradaPuertoOrigen" placeholder="‎ " optionLabel="nombre"
                                    formControlName="puertoorigen" optionValue="codigo" appendTo="body" [filter]="true"
                                    [showClear]="true" [virtualScroll]="true" styleClass="w-full"
                                    (onChange)="onPuertoChange($event)" size="small">
                                </p-select>
                                <label for="on_label">Puerto Origen</label>
                            </p-floatlabel>
                        </div>
                        <small
                            *ngIf="this.group_serviciostarifa.get('puertoorigen')?.invalid && (this.group_serviciostarifa.get('puertoorigen')?.touched)"
                            class="text-red-500 block h-2 text-xs">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlydTraficoST }"
                                [options]="ListaTodosTrafico" placeholder="‎ " optionLabel="nombre"
                                formControlName="trafico" optionValue="codigo" appendTo="body" styleClass="w-full"
                                size="small">
                            </p-select>
                            <label for="on_label">Trafico</label>
                        </p-floatlabel>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                        <div class="w-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('puertodestino')?.invalid && (this.group_serviciostarifa.get('puertodestino')?.touched), readonly: readonlyPuertoDestinoST }"
                                    [options]="ListaFiltradaPuertoDestino" placeholder="‎ " optionLabel="nombre"
                                    formControlName="puertodestino" optionValue="codigo" appendTo="body" [filter]="true"
                                    [showClear]="true" [virtualScroll]="true" styleClass="w-full md:w-56"
                                    (onChange)="actualizarListadoNaveViaje($event)"
                                    (onChange)="actualizarValidacionSucursal()" size="small">
                                </p-select>
                                <label for="on_label">Puerto Destino</label>
                            </p-floatlabel>
                        </div>
                        <small
                            *ngIf="this.group_serviciostarifa.get('puertodestino')?.invalid && (this.group_serviciostarifa.get('puertodestino')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyTipoFechaTarifaST }"
                                [options]="ListaTodosTipoFechaTarifa" placeholder="‎ " optionLabel="nombre"
                                formControlName="tipofechatarifa" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Tipo Fecha Tarifa</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-example-full-width-alterno-content-6">
                        <p-floatlabel class="w-full" variant="on">
                            <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFechaTarifaST }"
                                formControlName="fechatarifa" appendTo="body" iconDisplay="input" showIcon="true"
                                [showWeek]="false" styleClass="w-full" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                [readonlyInput]="false" (onInput)="formatDateInput($event)" size="small">
                            </p-datepicker>
                            <label for="on_label">F. Tarifa</label>
                        </p-floatlabel>
                    </div>
                </div>
                }@else{
                <div class="a-example-full-width-alterno-content-row">

                    <div class="a-example-full-width-alterno-content-2">
                        <p-floatlabel class="w-full" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyTransportisaSTST }"
                                [options]="ListaTodosTransportista" placeholder="‎" optionLabel="nombre"
                                formControlName="transportista" optionValue="nombre" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" (onChange)="onTransporteChange($event)"
                                size="small">
                            </p-select>
                            <label for="on_label">Transportista</label>
                        </p-floatlabel>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                        <div class="-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('puertoorigen')?.invalid && (this.group_serviciostarifa.get('puertoorigen')?.touched), readonly: readonlyPuertoOrigenST }"
                                    [options]="ListaFiltradaPuertoOrigen" placeholder="‎ " optionLabel="nombre"
                                    formControlName="puertoorigen" optionValue="codigo" appendTo="body" [filter]="true"
                                    [showClear]="true" [virtualScroll]="true" styleClass="w-full"
                                    (onChange)="onPuertoChange($event)" size="small">
                                </p-select>
                                <label for="on_label">Puerto Origen</label>
                            </p-floatlabel>
                        </div>
                        <small
                            *ngIf="this.group_serviciostarifa.get('puertoorigen')?.invalid && (this.group_serviciostarifa.get('puertoorigen')?.touched)"
                            class="text-red-500 block h-2 text-xs">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlydTraficoST }"
                                [options]="ListaTodosTrafico" placeholder="‎ " optionLabel="nombre"
                                formControlName="trafico" optionValue="codigo" appendTo="body" styleClass="w-full"
                                size="small">
                            </p-select>
                            <label for="on_label">Trafico</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-2">
                        <div class="w-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('puertodestino')?.invalid && (this.group_serviciostarifa.get('puertodestino')?.touched), readonly: readonlyPuertoDestinoST }"
                                    [options]="ListaFiltradaPuertoDestino" placeholder="‎ " optionLabel="nombre"
                                    formControlName="puertodestino" optionValue="codigo" appendTo="body" [filter]="true"
                                    [showClear]="true" [virtualScroll]="true" styleClass="w-full md:w-56"
                                    (onChange)="actualizarListadoNaveViaje($event)"
                                    (onChange)="actualizarValidacionSucursal()" size="small">
                                </p-select>
                                <label for="on_label">Puerto Destino</label>
                            </p-floatlabel>
                        </div>
                        <small
                            *ngIf="this.group_serviciostarifa.get('puertodestino')?.invalid && (this.group_serviciostarifa.get('puertodestino')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>
                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label" [ngClass]="{ readonly: readonlyTipoFechaTarifaST }"
                                [options]="ListaTodosTipoFechaTarifa" placeholder="‎ " optionLabel="nombre"
                                formControlName="tipofechatarifa" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Tipo Fecha Tarifa</label>
                        </p-floatlabel>
                    </div>
                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full" variant="on">
                            <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFechaTarifaST }"
                                formControlName="fechatarifa" appendTo="body" iconDisplay="input" showIcon="true"
                                [showWeek]="false" styleClass="w-full" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                [readonlyInput]="false" (onInput)="formatDateInput($event)" size="small">
                            </p-datepicker>
                            <label for="on_label">F. Tarifa</label>
                        </p-floatlabel>
                    </div>
                </div>
                }
                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label"
                                [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('moneda')?.invalid && (this.group_serviciostarifa.get('moneda')?.touched), readonly: readonlyMonedaST }"
                                [options]="ListaTodosMoneda" placeholder="‎ " optionLabel="nombre"
                                formControlName="moneda" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Moneda</label>
                        </p-floatlabel>
                        <small
                            *ngIf="this.group_serviciostarifa.get('moneda')?.invalid && (this.group_serviciostarifa.get('moneda')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div class="a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label"
                                [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('condicion')?.invalid && (this.group_serviciostarifa.get('condicion')?.touched), readonly: readonlyCondicionST }"
                                [options]="ListaTodosCondicion" placeholder="‎ " optionLabel="nombre"
                                formControlName="condicion" optionValue="codigo" appendTo="body"
                                styleClass="w-full md:w-56" (onChange)="onCondicionChange($event)" size="small">
                            </p-select>
                            <label for="on_label">Condición</label>



                        </p-floatlabel>
                        <small
                            *ngIf="this.group_serviciostarifa.get('condicion')?.invalid && (this.group_serviciostarifa.get('condicion')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div *ngIf='false' class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on"
                            style="flex: 1; display: flex; align-items: center;">

                            <input inputId="on_label" [ngClass]="{ readonly: readonlyAdicionalST }" pInputText
                                formControlName="cont_codigo" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Contrato</label>
                        </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on"
                            style="flex: 1; display: flex; align-items: center;">

                            <input inputId="on_label" [ngClass]="{ readonly: readonlyNumeroContratoST }" pInputText
                                formControlName="numerocontrato" appendTo="body" class="w-full md:w-56"
                                (onChange)="onNumeroContratoChange($event)" pSize="small" />
                            <label for="on_label">Número Contrato</label>
                            <button type="button" class="btn buscar-button" (click)="buscarContratoAyudaPivot()" style="margin-left: 10px; background-color: var(--color-btn-verde);
                                border-color: var(--color-btn-verde); color: white; display: flex;
                                align-items: center; padding: 6px 12px; border-radius: 6px;
                                box-shadow: 0 2px 6px rgba(0,0,0,0.1); transition: background-color 0.3s;">
                                <i class="pi pi-search" style="margin-right: 6px;"></i>
                            </button>

                        </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readonlyAdicionalST }" pInputText
                                formControlName="adicional" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Descripción</label>
                        </p-floatlabel>
                    </div>
                </div>
            </div>

            <div class="titulo_secciones">Flete</div>
            <div class="a-example-full-width-alterno-content-row">
                <div class="a-example-full-width-alterno-content-0_5">
                    <app-datatable #Flete [dataTable]="serviciosytarifas_dataflete" [metadataTable]="metadatableFlete"
                        [rowEdit]="true" [colorBtnEdit]="true" [addRow]="true" [colorBtnMas]="true" [rowDelete]="true"
                        [colorBtnDel]="true" [style]="estilos" [key]="'key'"
                        (rowAdded)="syncRowToOtherTableFlete($event, 'add')"
                        (rowDeleted)="syncRowToOtherTableFlete($event, 'delete')" [resaltarCabecera]="true"
                        (onDpChangeEvento)="onChangeFletes($event)" [onDpValueChangeEvento]="onDpValueChangeFleteEvento"
                        (onInputChangeEvento)="onChangeFletes($event)" [lineasTabla]="true"
                        (saveEdit)="calculateFlete($event)" [disableAddRow]="bloqueoFlete"
                        [disableDeleteRow]="bloqueoFlete" [disableEditRow]="bloqueoFlete" [filter]="false"
                        [sortable]="false" [btnEditAdelante]="true">
                    </app-datatable>
                </div>
                <div class="a-example-full-width-alterno-content-4">
                    <div class="a-example-full-width-alterno-content-column-2">
                        <div class="a-example-full-width-alterno-content-row">
                            <div class="a-example-full-width-alterno-content-2">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-select inputId="on_label"
                                        [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('pcmbl')?.invalid && (this.group_serviciostarifa.get('pcmbl')?.touched), readonly: readonlyPCMblST }"
                                        [options]="ListaTodosPCMBL" placeholder="‎ " optionLabel="nombre"
                                        formControlName="pcmbl" optionValue="codigo" appendTo="body"
                                        styleClass="w-full md:w-56" size="small">
                                    </p-select>
                                    <label for="on_label">P/C (MBL)</label>
                                </p-floatlabel>
                            </div>

                            <div class="a-example-full-width-alterno-content-2">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-select inputId="on_label"
                                        [ngClass]="{'ng-invalid ng-dirty': this.group_serviciostarifa.get('pchbl')?.invalid && (this.group_serviciostarifa.get('pchbl')?.touched), readonly: readonlyPCHblST }"
                                        [options]="ListaTodosPCHBL" placeholder="‎ " optionLabel="nombre"
                                        formControlName="pchbl" optionValue="codigo" appendTo="body"
                                        styleClass="w-full md:w-56" size="small">
                                    </p-select>
                                    <label for="on_label">P/C (HBL)</label>
                                </p-floatlabel>
                            </div>
                        </div>
                        <div class="a-example-full-width-alterno-content-row">
                            <div class="a-example-full-width-alterno-content-2">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyFleteTotalST }"
                                        formControlName="fletetotal" mode="decimal" [showButtons]="true"
                                        class="w-full md:w-56" [useGrouping]="false" [min]="0"
                                        [inputStyle]="{ width: '100%' }" size="small">
                                    </p-inputNumber>
                                    <label for="on_label">Flete Total</label>
                                </p-floatlabel>
                            </div>

                            <div class="a-example-full-width-alterno-content-2">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-inputNumber inputId="on_label" class="w-full md:w-56"
                                        [ngClass]="{ readonly: readonlyDiasLibresSobreeestadiaST }"
                                        formControlName="diaslibres" mode="decimal" [showButtons]="true"
                                        [useGrouping]="false" [min]="0" [inputStyle]="{ width: '100%' }" size="small">
                                    </p-inputNumber>
                                    <label for="on_label">Dias Libres Sobreestadia</label>
                                </p-floatlabel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p-tabView class="a-example-full-width-alterno-content" [(activeIndex)]="activeTabIndex">
                <p-tabPanel header="Servicios Adicionales" class="p-tabview-panel">
                    <div class="a-example-full-width-alterno-content">
                        <app-datatable #dtServiciosRef [dataTable]="serviciosytarifas_dataservicios"
                            [metadataTable]="metadatableServicio" [addRow]="true" [colorBtnMas]="true" [rowEdit]="true"
                            [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true" [style]="estilos"
                            [title]="'Servicios'" [key]="'key'"
                            (onDpChangeEvento)="onChangeServicios($event, 'servicios_adicionales')"
                            (onInputChangeEvento)="onChangeServicios($event,'servicios_adicionales')"
                            [resaltarCabecera]="true" [onDpValueChangeEvento]="onDpValueChangeEvento"
                            [lineasTabla]="true" [disableAddRow]="bloqueoServiciosAdicionales"
                            [disableDeleteRow]="bloqueoServiciosAdicionales"
                            [disableEditRow]="bloqueoServiciosAdicionales" [filter]="false" [sortable]="false"
                            [btnEditAdelante]="true">
                        </app-datatable>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Servicios Change Control">
                    <app-datatable #dtServiciosChangeControlRef [dataTable]="dtServiciosChangeControl"
                        [metadataTable]="mtServiciosChangeControl" [addRow]="true" [colorBtnMas]="true" [rowEdit]="true"
                        [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true" [style]="estilos"
                        [title]="'Servicios Change Control'" [customButtons]="custombServChangeControl"
                        [key]="'scot_item'" (onDpChangeEvento)="onChangeServicios($event,'servicios_change_control')"
                        (onInputChangeEvento)="onChangeServicios($event,'servicios_change_control')"
                        [resaltarCabecera]="true" [onDpValueChangeEvento]="onDpChangeTblServiciosChangeControl"
                        [lineasTabla]="true" [requireConfirmAddRow]="true" (confirmAddRow)="btnMasInit($event)"
                        [requireConfirmDeleteRow]="true" (confirmDeleteRow)="btnDeleteInit($event)"
                        [disableAddRow]="EnabledDatosServiciosChangeControl"
                        [disableDeleteRow]="EnabledDatosServiciosChangeControl"
                        (checkboxChange)="onCheckboxChangeServChangeCtrl($event)"
                        (rowInitAdded)="detectarNuevaFilaServChngCtrl($event)" [disableAddRow]="bloqueoChangeControl"
                        [disableDeleteRow]="bloqueoChangeControl" [disableEditRow]="bloqueoChangeControl"
                        [filter]="false" [sortable]="false" [btnEditAdelante]="true">
                    </app-datatable>
                </p-tabPanel>
            </p-tabView>
        </form>

    </p-accordionTab>

    <p-accordionTab header="Datos Embarque">

        <form [formGroup]="group_datosembarque">
            <div class="titulo_secciones">Datos de contrato / Datos adicionales</div>

            <div class="a-example-full-width-alterno-content-column-">
                <p-fieldset>
                    <ng-template #header>
                        <span class="text-xxs font-bold">DATOS DE CONTRATO</span>
                    </ng-template>
                    <div class="a-example-full-width-alterno-content-row py-3 px-3">
                        <div class="a-example-full-width-alterno-content-row">
                            <div class="a-checkbox a-example-full-width-alterno-content-3 bold-floatlabel">
                                <p-checkbox [ngClass]="{ readonly: readonlyCargaRefrigeradaDE }"
                                    formControlName="cargarefrigerada" [binary]="true" inputId="binary" appendTo="body"
                                    (onChange)="onCargaRefrigeradaChange($event)" size="small">
                                </p-checkbox>
                                <label for="on_label" style="font-weight: bold;">Carga Refrigerada</label>
                            </div>

                            <div class="a-example-full-width-alterno-content-3">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readOnlyTemperaturaDE }"
                                        formControlName="temperatura" mode="decimal" [showButtons]="true"
                                        [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                        size="small">
                                    </p-inputNumber>
                                    <label for="on_label">Temperatura (C°)</label>
                                </p-floatlabel>
                            </div>

                            <div class="a-checkbox a-example-full-width-alterno-content-3 bold-floatlabel">
                                <p-checkbox inputId="on_label" [ngClass]="{ readonly: readonlyCargaPeligrosaDE }"
                                    formControlName="cargapeligrosa" [binary]="true" inputId="binary" appendTo="body"
                                    (onChange)="onCargaPeligrosaChange($event)" size="small">
                                </p-checkbox>
                                <label for="on_label" style="font-weight: bold;">Carga Peligrosa</label>
                            </div>

                            <div class="a-example-full-width-alterno-content-4">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <p-select inputId="on_label"
                                        [ngClass]="{'ng-invalid ng-dirty': this.group_datosembarque.get('imoclass')?.invalid && (this.group_datosembarque.get('imoclass')?.touched), readonly: readonlyImoClassDE }"
                                        [options]="ListaTodosImoClass" placeholder="‎ " optionLabel="nombre"
                                        formControlName="imoclass" optionValue="codigo" appendTo="body"
                                        styleClass="w-full md:w-56" font-size="8px" size="small">
                                    </p-select>
                                    <label for="on_label">IMO Class</label>
                                </p-floatlabel>
                                <small
                                    *ngIf="this.group_datosembarque.get('imoclass')?.invalid && (this.group_datosembarque.get('imoclass')?.touched)"
                                    class="text-red-500">
                                    Este campo es obligatorio
                                </small>
                            </div>

                            <div class="card justify-content-center a-example-full-width-alterno-content-3">
                                <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                    <input inputId="on_label"
                                        [ngClass]="{'ng-invalid ng-dirty': this.group_datosembarque.get('imoun')?.invalid && (this.group_datosembarque.get('imoun')?.touched),  readonly: readOnlyImoUnDE }"
                                        pInputText formControlName="imoun" appendTo="body" class="w-full md:w-56"
                                        maxlength="4" pSize="small" />
                                    <label for="on_label">IMO UN</label>
                                </p-floatlabel>
                                <small
                                    *ngIf="this.group_datosembarque.get('imoun')?.invalid && (this.group_datosembarque.get('imoun')?.touched)"
                                    class="text-red-500">
                                    Este campo es obligatorio
                                </small>
                            </div>


                            <div class="a-checkbox a-example-full-width-alterno-content-3 bold-floatlabel">
                                <p-checkbox [ngClass]="{ readonly: readonlyRoundTripDE }" formControlName="roundtrip"
                                    [binary]="true" inputId="binary" appendTo="body" size="small">
                                </p-checkbox>
                                <label>RoundTrip</label>
                            </div>


                        </div>
                    </div>
                </p-fieldset>

                <p-fieldset legend="DATOS ADICIONALES" class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-row py-3 px-3">
                        <div class="a-example-full-width-alterno-content-column a-example-full-width-alterno-content">
                            <div class="a-example-full-width-alterno-content-row">
                                <div class="a-example-full-width-alterno-content  flex align-items-center">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                        <p-select inputId="on_label" [ngClass]="{ readonly: readonlyShipperDE }"
                                            [options]="ListaTodosShipper" placeholder="‎ " optionLabel="nombre"
                                            formControlName="shipper" optionValue="nombre" appendTo="body"
                                            [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                                            virtualScroll="true" virtualScrollItemSize="36" size="small"
                                            (onChange)="onShipperChange()">
                                        </p-select>
                                        <label for="on_label">Shipper</label>
                                    </p-floatlabel>
                                    <p-button icon="pi pi-replay" size="small" variant="outlined"
                                        (onClick)="actualizarListaEntidad(10,this.ListaTodosShipper,'Shipper')"
                                        styleClass="h-full"></p-button>
                                </div>
                            </div>
                            <div class="a-example-full-width-alterno-content-row">
                                <div class="a-example-full-width-alterno-content-row">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
                                        <textarea inputId="on_label"
                                            [ngClass]="{ readonly: readonlyShipperDE }" id="float-input"
                                            rows="5" cols="30" pTextarea formControlName="desc_shipper"
                                            style="width: 100%" class="w-full md:w-56" pSize="small" placeholder="‎ ">
                                </textarea>
                                        <label for="on_label">Shipper Descripción</label>
                                    </p-floatlabel>
                                </div>
                            </div>
                            <div class="a-example-full-width-alterno-content-row">
                                <div class="a-example-full-width-alterno-content  flex align-items-center">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                        <p-select inputId="on_label" [ngClass]="{ readonly: readonlyConsigneeDE }"
                                            [options]="ListaTodosConsignee" placeholder="‎ " optionLabel="nombre"
                                            formControlName="consignee" optionValue="nombre" appendTo="body"
                                            [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                                            virtualScroll="true" virtualScrollItemSize="36" size="small"
                                            (onChange)="onConsigneeChange()">
                                        </p-select>
                                        <label for="on_label">Consignee</label>
                                    </p-floatlabel>
                                    <p-button icon="pi pi-replay" size="small" variant="outlined"
                                        (onClick)="actualizarListaEntidad(1,this.ListaTodosConsignee,'Consignee')"
                                        styleClass="h-full"></p-button>
                                </div>
                            </div>
                             <div class="a-example-full-width-alterno-content-row">
                                <div class="a-example-full-width-alterno-content-row">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
                                        <textarea inputId="on_label"
                                            [ngClass]="{ readonly: readonlyConsigneeDE }" id="float-input"
                                            rows="5" cols="30" pTextarea formControlName="desc_consignee"
                                            style="width: 100%" class="w-full md:w-56" pSize="small" placeholder="‎ ">
                                </textarea>
                                        <label for="on_label">Consignee Descripción</label>
                                    </p-floatlabel>
                                </div>
                            </div>
                            <div class="a-example-full-width-alterno-content-row">
                                <div class="a-example-full-width-alterno-content  flex align-items-center">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                        <p-select inputId="on_label" [ngClass]="{ readonly: readonlyNotifyDE }"
                                            [options]="ListaTodosNotify" placeholder="‎ " optionLabel="nombre"
                                            formControlName="notify" optionValue="nombre" appendTo="body"
                                            [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                                            virtualScroll="true" virtualScrollItemSize="36" size="small"
                                            (onChange)="onNotifyChange()">
                                        </p-select>
                                        <label for="on_label">Notify</label>
                                    </p-floatlabel>
                                    <p-button icon="pi pi-replay" size="small" variant="outlined"
                                        (onClick)="actualizarListaEntidad(1,this.ListaTodosNotify,'Notify')"
                                        styleClass="h-full"></p-button>
                                </div>
                            </div>
                            <div class="a-example-full-width-alterno-content-row">
                                <div class="card flex justify-content-center a-example-full-width-alterno-content">
                                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                        <input inputId="on_label" [ngClass]="{ readonly: readonlyReferenciaDE }"
                                            pInputText formControlName="referencia" appendTo="body"
                                            class="w-full md:w-56" size="small" />
                                        <label for="on_label">Referencia</label>
                                    </p-floatlabel>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-fieldset>
            </div>
            <div class="titulo_secciones">Flete</div>
            <div class="a-example-full-width-alterno-content">
                <app-datatable #dtFleteDetRef [dataTable]="datosembarque_dataflete"
                    [metadataTable]="metadatableFleteEmbarque" [filter]="true" [colorBtnMas]="true" [rowEdit]="true"
                    [colorBtnEdit]="true" [style]="estilos" [title]="' '" [key]="'dcot_item'" [resaltarCabecera]="true"
                    [lineasTabla]="true" [disableDeleteRow]="bloqueoSegundoFlete" [disableEditRow]="bloqueoSegundoFlete"
                    [btnEditAdelante]="true">
                </app-datatable>
            </div>
        </form>

    </p-accordionTab>
    <p-accordionTab header="Observaciones">

        <form [formGroup]="group_observaciones">
            <div class="titulo_secciones">Datos de observaciones</div>
            <div class="a-example-full-width-alterno-content-column">
                <div class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-row">
                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readonlyTiempoViajeObs }"
                                    formControlName="tiempoviaje" mode="decimal" [showButtons]="true"
                                    [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                    size="small">
                                </p-inputNumber>
                                <label for="on_label">Tiempo viaje (dias)</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-2">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-inputNumber inputId="on_label" [ngClass]="{ readonly: readonlySobreestadiaObs }"
                                    formControlName="sobreestadia" mode="decimal" [showButtons]="true"
                                    [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                    size="small">
                                </p-inputNumber>
                                <label for="on_label">Sobreestadia (días)</label>
                            </p-floatlabel>
                        </div>
                    </div>
                </div>
                <div class="a-example-full-width-alterno-content">
                    <div class="a-example-full-width-alterno-content-row">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel textarea-fix" variant="on">
                            <textarea inputId="on_label" [ngClass]="{ readonly: readonlyInstruccionesEmbarqueObs }"
                                id="float-input" rows="5" cols="30" pTextarea formControlName="instrucciones"
                                style="width: 100%" class="w-full md:w-56" pSize="small" placeholder="‎ ">
                                </textarea>
                            <label for="on_label">Instrucciones de embarque</label>
                        </p-floatlabel>
                    </div>
                </div>
            </div>
        </form>

    </p-accordionTab>


    <p-accordionTab header="Viaje (Itinerario)">

        <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="flex: 1; padding-right: 10px;">
                <div class="titulo_secciones">Itinerarios</div>
            </div>
            <p-button label="Crear Nave Viaje" icon="pi pi-plus" styleClass="p-button-sm p-button-primary"
                (onClick)="popUpNaveViaje()"></p-button>
        </div>
        <div class="a-example-full-width-alterno-content">
            <app-datatable #dtItinerarioRef [dataTable]="viajeitinerario_dataitinerario"
                [metadataTable]="metadatableItinerario" [filter]="false" [addRow]="true" [colorBtnMas]="true"
                [rowEdit]="true" [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true" [key]="'key'"
                (rowAdded)="syncRowToOtherTable($event, 'add')" (rowDeleted)="syncRowToOtherTable($event, 'delete')"
                [resaltarCabecera]="true" [lineasTabla]="true" [onDpValueChangeEvento]="onChangeTblViajeItinerario"
                [disableAddRow]="bloqueoViajeItinerario" [disableDeleteRow]="bloqueoViajeItinerario"
                [disableEditRow]="bloqueoViajeItinerario" [btnEditAdelante]="true" [showSort]="false">
            </app-datatable>
        </div>

        @if(!solo_aereo){
        <div class="titulo_secciones">Detalle / Nave viaje</div>
        <div class="a-example-full-width-alterno-content">
            <app-datatable #dtDetItinerarioRef [dataTable]="viajeitinerario_datanave"
                [metadataTable]="metadatableDataNave" [filter]="false" [rowEdit]="true" [colorBtnEdit]="true"
                [rowDelete]="true" [colorBtnDel]="true" [style]="estilos" [title]="' '" [key]="'ovnv_item'"
                [resaltarCabecera]="true" [lineasTabla]="true" [disableAddRow]="bloqueoViajeItinerario"
                [disableDeleteRow]="bloqueoViajeItinerario" [disableEditRow]="bloqueoViajeItinerario"
                [btnEditAdelante]="true">
            </app-datatable>
        </div>
        }

    </p-accordionTab>

    @if(from_operaciones && solo_aereo && ListaTipoPaquete?.length > 0 && ListaImo?.length > 0 && ListaComodity?.length
    > 0 &&
    ListaBultos?.length > 0){
    <p-accordionTab header="Datos de Emisión">
        <app-ov-datos-de-emision #tabDatosEmision [listados]="maestrosParaEmision$ | async"
            [btns_habilitados]="esVisualizar" [bloqueoBtns]="bloqueoViajeItinerario" [oRow]="initDatosEmision">
        </app-ov-datos-de-emision>
    </p-accordionTab>
    }

    <p-accordionTab header="Novedades">

        <form [formGroup]="group_novedades">
            <div class="titulo_secciones">Novedades</div>
            <div class="a-example-full-width-alterno-content-column">
                @if(!solo_aereo){
                <p-fieldset>
                    <ng-template #header>
                        <span class="text-xxs font-bold">DATOS VIAJE</span>
                    </ng-template>
                    <div class="a-example-full-width-alterno-content-row py-3 px-3">
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel inputId="on_label" class="w-full md:w-56" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readonlyNroBookingNov }" pInputText
                                    formControlName="numerobooking" appendTo="body" class="w-full md:w-56"
                                    pSize="small" />
                                <label for="on_label">N° booking</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readOnlyViajeNov }" pInputText
                                    formControlName="viaje" appendTo="body" class="w-full md:w-56" pSize="small" />
                                <label for="on_label">Viaje</label>
                            </p-floatlabel>
                        </div>
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFZarpeNov }"
                                    formControlName="zarpe" appendTo="body" [iconDisplay]="'input'" [showIcon]="true"
                                    [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    [readonlyInput]="false" (onInput)="formatDateInput($event)"
                                    styleClass="w-full md:w-56" size="small">
                                </p-datepicker>
                                <label for="on_label">F. Zarpe</label>
                            </p-floatlabel>
                        </div>
                        <div class="p-on_label a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFEtaEtdNov }"
                                    formControlName="etaetd" appendTo="body" [iconDisplay]="'input'" [showIcon]="true"
                                    [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                    [readonlyInput]="false" (onInput)="formatDateInput($event)"
                                    styleClass="w-full md:w-56" size="small">
                                </p-datepicker>
                                <label for="on_label">F. ETA</label>
                            </p-floatlabel>
                        </div>
                        <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readOnlyNaveNov }" pInputText
                                    formControlName="nave" appendTo="body" class="w-full md:w-56" pSize="small" />
                                <label for="on_label">Nave</label>
                            </p-floatlabel>
                        </div>
                    </div>
                </p-fieldset>
                }
                <p-fieldset>
                    <ng-template #header>
                        <span class="text-xxs font-bold">DATOS DOCUMENTO</span>
                    </ng-template>
                    <div class="a-example-full-width-alterno-content-row py-3 px-3">
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full" variant="on">
                                <p-select inputId="on_label" [ngClass]="{ readonly: readonlyDepositoNov }"
                                    [options]="ListaTodosDeposito" placeholder="‎ " optionLabel="nombre"
                                    formControlName="deposito" optionValue="nombre" appendTo="body" [filter]="true"
                                    [showClear]="true" styleClass="w-full" (onChange)="onDepositoChange($event)"
                                    size="small">
                                </p-select>
                                @if(solo_aereo == true && from_operaciones == true){
                                <label for="on_label">Almacén</label>
                                }@else {
                                <label for="on_label">Depósito</label>
                                }
                            </p-floatlabel>
                        </div>

                        @if(solo_aereo == false){

                        <div class="a-checkbox a-example-full-width-alterno-content-3 bold-floatlabel">
                            <p-checkbox [ngClass]="{ readonly: readonlyBlNietoNov }" formControlName="blnieto"
                                [binary]="true" inputId="binary" appendTo="body" size="small">
                            </p-checkbox>
                            <label>BL Nieto</label>
                        </div>
                        }

                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full" variant="on">
                                <input inputId="on_label"
                                    [ngClass]="{'ng-invalid ng-dirty': this.group_novedades.get('blhijo')?.invalid && (this.group_novedades.get('blhijo')?.touched), readonly: readonlyBlHijoNov }"
                                    pInputText formControlName="blhijo" appendTo="body" class="w-full"
                                    (keydown.enter)="onHblChange($event)" (blur)="onHblChange($event)" pSize="small" />
                                <label for="on_label">{{nombre_bl}}</label>
                            </p-floatlabel>
                            <small
                                *ngIf="this.group_novedades.get('blhijo')?.invalid && (this.group_novedades.get('blhijo')?.touched)"
                                class="text-red-500">
                                Este campo es obligatorio
                            </small>
                        </div>

                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readonlyBlMasterNov }" pInputText
                                    formControlName="blmaster" appendTo="body" class="w-full" pSize="small"
                                    (blur)="fnOnChangeMblDatosEmision()" />
                                <label for="on_label">{{nombre_mbl}}</label>
                            </p-floatlabel>
                        </div>
                        @if(solo_aereo == true && from_operaciones == true) {
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel inputId="on_label" class="w-full md:w-56" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readonlyNroBookingNov }" pInputText
                                    formControlName="numerobooking" appendTo="body" class="w-full md:w-56"
                                    pSize="small" />
                                <label for="on_label">N° booking</label>
                            </p-floatlabel>
                        </div>
                        }
                        @else{
                        <div class="a-example-full-width-alterno-content-3">
                            <p-floatlabel class="w-full" variant="on">
                                <input inputId="on_label" [ngClass]="{ readonly: readonlyContenedorNov }" pInputText
                                    formControlName="contenedor" appendTo="body" class="w-full" pSize="small" />
                                <label for="on_label">Contenedor</label>
                            </p-floatlabel>
                        </div>
                        }
                    </div>
                </p-fieldset>
            </div>
        </form>

    </p-accordionTab>
    <p-accordionTab header="Archivos">

        <form [formGroup]="group_archivos">
            <div class="titulo_secciones">Datos archivo</div>
            <div class="a-example-full-width-alterno-content">
                <button type="button" class="btn-subir-archivo" (click)="fileInput.click()">
                    <i class="pi pi-upload"></i> Subir archivo
                </button>
                <input type="file" #fileInput hidden (change)="onFileSelected($event)"
                    accept="image/*,.xls,.xlsx,.pdf,.docx,.txt,.doc,.msg,.png,.jpg" />
            </div>
            <div class="titulo_secciones">Listado archivos</div>
            <div class="a-example-full-width-alterno-content">
                <div class="a-example-full-width-alterno-content">
                    <app-datatable #dtArchivosRef [dataTable]="archivos_dataarchivos"
                        [metadataTable]="metadatableDataArchivos" [filter]="true" [rowEdit]="true" [colorBtnEdit]="true"
                        [rowDelete]="true" [colorBtnDel]="true" [key]="'ovar_codigo'" [style]="estilos" [title]="' '"
                        [blockedColumns]="blockedColumnsArchivos" [resaltarCabecera]="true" [lineasTabla]="true"
                        [customButtons]="btns_archivos" [btnEditAdelante]="true">
                    </app-datatable>
                </div>
            </div>
        </form>

    </p-accordionTab>

    <p-accordionTab header="Eventos / Tarea">

        <form [formGroup]="group_eventostareas">

            <div class="titulo_secciones">Eventos Tareas</div>

            <div class="a-example-full-width-alterno-content">
                <app-datatable #dtEventosRef [dataTable]="eventostareas_dataeventos"
                    [metadataTable]="metadatableDataEventos" [filter]="true" [addRow]="true" [colorBtnMas]="true"
                    [rowEdit]="true" [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true" [key]="'key'"
                    [style]="estilos" [title]="' '" [blockedColumns]="blockedColumnsEventos" [modifiedRow]="modifiedRow"
                    (rowInitAdded)="detectarNuevaFilaTablaEventos($event, 'add')" [resaltarCabecera]="true"
                    [lineasTabla]="true" [rowDialog]="true" [btnEditAdelante]="true">
                </app-datatable>
            </div>
        </form>

    </p-accordionTab>
    @if(!solo_aereo){
    <p-accordionTab header="Servicios Locales">

        <form [formGroup]="group_servicioslocales">
            <div class="titulo_secciones">Datos servicios locales</div>
            <div style="margin-top: 2%;"></div>
            <div class="a-example-full-width-alterno-content-column">
                <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyCodigoOperacionDSL }" pInputText
                                formControlName="codigooperacion" appendTo="body" class="w-full md:w-56"
                                pSize="small" />
                            <label for="on_label">Código operación</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyNumeroOpeacionDSL }" pInputText
                                formControlName="numerooperacion" appendTo="body" class="w-full md:w-56"
                                pSize="small" />
                            <label for="on_label">Numero operación</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyFechaEmisionDSL }"
                                formControlName="fechaemision" appendTo="body" [iconDisplay]="'input'" [showIcon]="true"
                                [showWeek]="false" dateFormat="dd/mm/yy" (onChange)="onFechaEmiChange($event)"
                                [showOnFocus]="false" [readonlyInput]="false" (onInput)="formatDateInput($event)"
                                styleClass="w-full md:w-56" size="small">
                            </p-datepicker>
                            <label for="on_label">Fecha emisión</label>
                        </p-floatlabel>
                    </div>

                    <!-- <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyClienteDSL }" pInputText
                                formControlName="clienteDSL" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Cliente</label>
                        </p-floatlabel>
                    </div> -->

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select inputId="on_label" [options]="ListaTodosCliente" placeholder="‎ "
                                optionLabel="nombre" formControlName="clienteDSL" optionValue="codigo" appendTo="body"
                                [filter]="true" styleClass="w-full md:w-56" virtualScroll="true"
                                virtualScrollItemSize="36" size="small">
                            </p-select>
                            <label for="on_label">Cliente</label>
                        </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyTransportistaAMDSL }" pInputText
                                formControlName="transportistaam" appendTo="body" class="w-full md:w-56"
                                pSize="small" />
                            <label for="on_label">Transportista (A/M)</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyAlmacenDSL }" pInputText
                                formControlName="almacen" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Almacén</label>
                        </p-floatlabel>
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyAgenciaMaritimaDSL }" pInputText
                                formControlName="agencia" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Agencia marítima</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyTerminalPortuarioDSL }" pInputText
                                formControlName="terminal" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Terminal portuario</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readOnlyCondicionEmbarqueDSL }" pInputText
                                formControlName="condicion" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Condición embarque</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select [options]="ListaTodosTransportista" placeholder="‎ " optionLabel="nombre"
                                formControlName="transportistaTerre" optionValue="codigo" appendTo="body"
                                [filter]="true" [showClear]="true" styleClass="w-full md:w-56"
                                (onChange)="onTransTerrChange($event)" size="small">
                            </p-select>
                            <label for="on_label">Transportista (T)</label>
                        </p-floatlabel>
                    </div>

                    @if(solo_aereo == false){
                    <div class="InputSwitch a-example-full-width-alterno-content-3">
                        <p-inputSwitch [ngClass]="{ readonly: readonlySADADSL }" formControlName="sada" />SADA
                    </div>
                    }
                    <div class="InputSwitch a-example-full-width-alterno-content-3">
                        <p-inputSwitch [ngClass]="{ readonly: readonlyIMODSL }" formControlName="imo" />IMO
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row">
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input inputId="on_label" [ngClass]="{ readonly: readonlyTipoDSL }" pInputText
                                formControlName="tipo" appendTo="body" class="w-full md:w-56" pSize="small" />
                            <label for="on_label">Tipo</label>
                        </p-floatlabel>
                    </div>
                    <!-- <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyVigenciaDesdeDSL }"
                                formControlName="vigenciadesde" appendTo="body" [iconDisplay]="'input'"
                                [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                [readonlyInput]="false" (onInput)="formatDateInput($event)" styleClass="w-full md:w-56"
                                size="small">
                            </p-datepicker>
                            <label for="on_label">Vigencia desde</label>
                        </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-datepicker inputId="on_label" [ngClass]="{ readonly: readonlyVigenciaHastaDSL }"
                                formControlName="vigenciahasta" appendTo="body" [iconDisplay]="'input'"
                                [showIcon]="true" [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false"
                                [readonlyInput]="false" (onInput)="formatDateInput($event)" styleClass="w-full md:w-56"
                                size="small">
                            </p-datepicker>
                            <label for="on_label">Vigencia hasta</label>
                        </p-floatlabel>
                    </div> -->
                    <div class="a-example-full-width-alterno-content-3">
                        <div class="w-full flex align-items-center">
                            <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                                <p-select [options]="ListaSucursales" placeholder="‎ " optionLabel="label"
                                    formControlName="sucursal" optionValue="value" appendTo="body" [filter]="true"
                                    [showClear]="true" styleClass="w-full md:w-56" size="small">
                                </p-select>
                                <label for="on_label">Sucursal</label>
                            </p-floatlabel>
                        </div>
                        <small
                            *ngIf="this.group_servicioslocales.get('sucursal')?.invalid && (this.group_servicioslocales.get('sucursal')?.touched)"
                            class="text-red-500">
                            Este campo es obligatorio
                        </small>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <div class="flex items-center gap-1">
                            <p-checkbox inputId="isintegral" [binary]="true" formControlName="isintegral"
                                [readonly]="adicional" />
                            <label for="isintegral" class="ml-2"> Servicio Integral </label>
                        </div>
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row">
                    <!-- <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select [options]="ListaOriginalTipoPaquete" placeholder="‎ " optionLabel="label"
                                formControlName="contenedorsli" optionValue="value" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Contenedor</label>
                        </p-floatlabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="cantidadctnr"
                                [showButtons]="true" [useGrouping]="false" [inputStyle]="{ width: '100%' }"
                                class="w-full md:w-56" size="small">
                            </p-inputNumber>
                            <label for="on_label">Cantidad</label>
                        </p-floatLabel>
                    </div> -->
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select [options]="listRutas" placeholder="‎ " optionLabel="label" formControlName="rutas"
                                optionValue="value" appendTo="body" [filter]="true" [showClear]="true"
                                styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Rutas</label>
                        </p-floatlabel>
                    </div>
                    <p-button label="" (onClick)="verZonas()" icon="pi pi-eye" pTooltip="Visualizar Zonas"
                        [disabled]="esVisualizar"></p-button>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="cifEjecVta" [showButtons]="true"
                                (onInput)="onChangeCif('EVE','EJEC')" [useGrouping]="false"
                                [inputStyle]="{ width: '100%' }" class="w-full md:w-56" size="small">
                            </p-inputNumber>
                            <label for="on_label">Monto CIF (Ejecutivo)</label>
                        </p-floatLabel>
                    </div>
                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="cifLogistico" [showButtons]="true"
                                (onInput)="onChangeCif('EVE', 'LOG')" [useGrouping]="false"
                                [inputStyle]="{ width: '100%' }" class="w-full md:w-56" size="small">
                            </p-inputNumber>
                            <label for="on_label">Monto CIF (Logistico)</label>
                        </p-floatLabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="montodam" [showButtons]="true"
                                [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                size="small">
                            </p-inputNumber>
                            <label for="on_label">Monto DAM</label>
                        </p-floatLabel>
                    </div>
                </div>

                <div class="a-example-full-width-alterno-content-row">
                    <div class="a-w4">
                        <p-floatlabel class="w-full md:w-56" variant="on">
                            <p-datepicker inputId="on_label" formControlName="fechasl" appendTo="body" [showIcon]="true"
                                [showWeek]="false" dateFormat="dd/mm/yy" [showOnFocus]="false" [readonlyInput]="false"
                                styleClass="w-full md:w-56">
                            </p-datepicker>
                            <label for="on_label">Fecha SL</label>
                        </p-floatlabel>
                    </div>

                    @if(rol === '1') {
                    <div class="w-auto flex gap-4 align-content-center">
                        <p-checkbox formControlName="promedio" [binary]="true" inputId="binary" appendTo="body"
                            size="small">
                        </p-checkbox>
                        <label>Promedio</label>
                    </div>
                    }

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="peso" [showButtons]="true"
                                [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                size="small">
                            </p-inputNumber>
                            <label for="on_label">Peso</label>
                        </p-floatLabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select [options]="ListaUnidadMedida" placeholder="‎ " optionLabel="label"
                                formControlName="unmd_peso" optionValue="value" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Unidad de medida (peso)</label>
                        </p-floatlabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatLabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-inputNumber inputId="on_label" formControlName="volumen" [showButtons]="true"
                                [useGrouping]="false" [inputStyle]="{ width: '100%' }" class="w-full md:w-56"
                                size="small">
                            </p-inputNumber>
                            <label for="on_label">Volumen</label>
                        </p-floatLabel>
                    </div>

                    <div class="card flex justify-content-center a-example-full-width-alterno-content-3">
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <p-select [options]="ListaUnidadMedida" placeholder="‎ " optionLabel="label"
                                formControlName="unmd_volumen" optionValue="value" appendTo="body" [filter]="true"
                                [showClear]="true" styleClass="w-full md:w-56" size="small">
                            </p-select>
                            <label for="on_label">Unidad de medida (volumen)</label>
                        </p-floatlabel>
                    </div>

                </div>

                <div class="a-w1-row" style="padding-top: 20px;">
                    <p-button label="Buscar Tarifa" (onClick)="searchTarifa()"
                        [disabled]="esVisualizar == true ? esVisualizar : !modovisualizar" class="btn-sli"></p-button>
                    <p-button label="Ver Tarifario" (onClick)="verTarifarioSli()"
                        [disabled]="esVisualizar == true ? esVisualizar : !modovisualizar" class="btn-sli"></p-button>
                    <p-button [hidden]="adicional === true" [disabled]="esVisualizar == true ? esVisualizar : agrupar"
                        label="Agrupar" (onClick)="AgruparPoppup()"></p-button>
                    <p-button [hidden]="adicional === true"
                        [disabled]="esVisualizar == true ? esVisualizar : desagrupar" label="Desagrupar"
                        (onClick)="desagruparServicio()"></p-button>
                    <p-button [hidden]="adicional === false" label="Prefacturar"
                        [disabled]="esVisualizar == true ? esVisualizar : prefacturar" [loading]="cargandoPrefactura"
                        (onClick)="PrefacturarServicios('A')"></p-button>
                    <p-button [hidden]="adicional === false" label="Cancelar"
                        [disabled]="esVisualizar == true ? esVisualizar : cancelar"
                        (onClick)="cancelarServicio()"></p-button>
                    <p-button [hidden]="adicional === false" label="Generar Orden de Servicio"
                        [disabled]="esVisualizar == true ? esVisualizar : generaros" (onClick)="generarOS()"></p-button>
                </div>

                <div class="a-example-full-width-alterno-content-row">
                    <p-accordionTab header="Tarifas - Servicios SLI" style="width: 100%;" [selected]="onExpanded">
                        <p-tabView class="a-example-full-width-alterno-content">

                            <p-tabPanel header="Tarifario">
                                <div class="w-full">
                                    <p-accordion [multiple]="true">
                                        <p-accordionTab header="Servicio Logístico" [selected]="onExpanded">

                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableTarifaServicioLogistico"
                                                    [metadataTable]="metadataTableTarifaServicioLogistico" [key]="'key'"
                                                    [btnResetFiltros]="true" [filter]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                (onChange)="addTarifa($event,row,'I','SLI')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                        <p-accordionTab header="Almacén" [selected]="onExpanded">

                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableTarifaAlmacen"
                                                    [metadataTable]="metadataTableTarifaAlmacen" [key]="'key'"
                                                    [styleRow]="styleRowAlm" [btnResetFiltros]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                (onChange)="addTarifa($event,row,'I','ALM')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                        <p-accordionTab header="Transporte" [selected]="onExpanded">

                                            <form [formGroup]="group_Transporte" style="padding: 10px;">
                                                <div class="a-w1">
                                                    <div class="a-w3">
                                                        <p-floatlabel class="w-full md:w-56" variant="on">
                                                            <p-select inputId="on_label" [options]="ListaTodosCondicion"
                                                                optionLabel="nombre" formControlName="condicion"
                                                                optionValue="codigo" appendTo="body"
                                                                styleClass="w-full md:w-56"
                                                                (onChange)="buscarTransporte($event)"
                                                                [ngClass]="{ readonly: soloLectura }">
                                                            </p-select>
                                                            <label for="on_label">Condición</label>
                                                        </p-floatlabel>
                                                    </div>
                                                </div>
                                            </form>
                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableTransporte"
                                                    [metadataTable]="metadataTableTransporte" [key]="'key'"
                                                    [btnResetFiltros]="true" [filter]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                (onChange)="addTarifa($event,row,'I','TNS')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                        <p-accordionTab header="Agenciamiento" [selected]="onExpanded">

                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableAgeAduana"
                                                    [metadataTable]="metadataTableAgeAduana" [key]="'key'"
                                                    [btnResetFiltros]="true" [filter]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                [disabled]="row?.concepto?.value === '003' && group_datosgenerales.get('regimen')?.value === '001'"
                                                                (onChange)="addTarifa($event,row,'I','AGE')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                        <p-accordionTab header="Tarifas Extra" [selected]="onExpanded">

                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableExtras"
                                                    [metadataTable]="metadataTableExtras" [key]="'key'"
                                                    [btnResetFiltros]="true" [filter]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                (onChange)="addTarifa($event,row,'I','EXT')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                        <p-accordionTab header="SLI – Tacna" [selected]="onExpanded">

                                            <div class="a-w1">
                                                <app-datatable [dataTable]="dataTableTc"
                                                    [metadataTable]="metadataTableTc" [key]="'key'"
                                                    [btnResetFiltros]="true" [filter]="true">
                                                    <ng-template #addHeaderStart>
                                                        <th class="header">
                                                            <div class="items-header">
                                                                <span>Seleccionar</span>
                                                            </div>
                                                        </th>
                                                    </ng-template>
                                                    <ng-template #addBodyStart let-row="row">
                                                        <td class="a-datatable-datos-body-accion row-space">
                                                            <p-checkbox [inputId]="row.key" name="group"
                                                                [value]="row.key"
                                                                (onChange)="addTarifa($event,row,'I','TC')" />
                                                        </td>
                                                    </ng-template>
                                                </app-datatable>
                                            </div>

                                        </p-accordionTab>
                                    </p-accordion>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Tarifas" [disabled]="true">
                                <div class="a-example-full-width-alterno-content" style="position: relative;"
                                    *ngIf="bloqueoCheckboxSLI=='nolock'">
                                    <app-datatable [dataTable]="servicioslocales_tarifa"
                                        [metadataTable]="metadatableTarifa" [filter]="true" [filterGlobal]="true"
                                        [paginacion]="false" (Row)="row = $event"
                                        (checkboxChange)="onCheckboxChangeTarifas($event)"
                                        [customButtons]="custombTarifas" [resaltarCabecera]="true" [lineasTabla]="true"
                                        [disableAddRow]="bloqueoTarifa" [disableDeleteRow]="bloqueoTarifa"
                                        [disableEditRow]="bloqueoTarifa">
                                    </app-datatable>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Descripción" [disabled]="true">
                                <textarea [ngClass]="{ readonly: readonlyDescripcionDSL }" id="float-input" rows="5"
                                    cols="30" pInputTextarea formControlName="descripcion"
                                    style="width: 100%;"></textarea>
                            </p-tabPanel>
                            <p-tabPanel header="Observación" [disabled]="true">
                                <div class="a-example-full-width-alterno-content">
                                    <app-datatable #dtSliObsRef [dataTable]="servicioslocales_dataObservaciones"
                                        [metadataTable]="metadatableDataObservaciones" [filter]="true"
                                        [resaltarCabecera]="true" [lineasTabla]="true"
                                        [disableAddRow]="bloqueoObservaciones" [disableDeleteRow]="bloqueoObservaciones"
                                        [disableEditRow]="bloqueoObservaciones">
                                    </app-datatable>
                                </div>
                            </p-tabPanel>
                        </p-tabView>

                    </p-accordionTab>
                </div>
                <!-- <div class="a-example-full-width-alterno-content-column">
                    <div class="a-example-full-width-alterno-content">
                        <app-datatable #dtSliDetRef [dataTable]="servicioslocales_datadetalle"
                            [metadataTable]="metadatableDataDetalle" [blockedColumns]="blockedColumnsSL"
                            [rowEdit]="true" [colorBtnEdit]="true" [rowDelete]="true" [colorBtnDel]="true" [key]="'key'"
                            [resaltarCabecera]="true" [lineasTabla]="true" [addRow]="false"
                            [disableAddRow]="bloqueoTarifa" [disableDeleteRow]="bloqueoTarifa"
                            [disableEditRow]="bloqueoTarifa">
                        </app-datatable>
                    </div>
                </div> -->

                <div class="a-example-full-width-alterno-content-column">
                    <div class="a-example-full-width-alterno-content">
                        <app-datatable #dtServiciosRefdt [dataTable]="servicioslocales_datadetalle"
                            [blockedColumnsAdd]="bloqueoadd" [metadataTable]="metadatableDataDetalle"
                            [btnDisabled]="!modovisualizar" [key]="'key'" [blockedColumnsEdit]="bloqueoColumnas"
                            [customButtons]="reset" [rowEdit]="modovisualizar" [colorBtnEdit]="true"
                            [editDisabled]="edicion === true || !desagrupar" (rowEditInit)="onEditRowInit($event)"
                            [colorBtnDel]="true" [resaltarCabecera]="true"
                            [disableAddRow]="bloqueoAddAdicionales || !modovisualizar"
                            [customLeyendasHex]="leyendasTblSLI" [addRow]="true"
                            (onDpChangeEvento)="onSelectChange($event)" [onDpValueChangeEvento]="onDpChangeTbl"
                            (addEmptyRowEvent)="onAddRowInit($event)" (saveEdit)="mapearEdit($event)"
                            (cancelEdit)="onCancelEditInit($event)" [styleRow]="styleRow"
                            [title]="'Resumen Servicios SLI'">
                            <ng-template #addHeaderStart>
                                @if (modovisualizar) {
                                <th class="header p-d-flex p-ai-center p-gap-2">
                                    <input style="width:20%" type="checkbox" id="checkAllServicios"
                                        [checked]="todosSeleccionados" (change)="toggleSeleccionarTodos($event)"
                                        [disabled]="!desagrupar" />
                                    <label for="checkAllServicios">Acción</label>
                                </th>
                                }
                                @else {
                                <th class="header">Leyenda</th>
                                }
                            </ng-template>

                            <ng-template #addBodyStart let-row="row">

                                @if (modovisualizar) {
                                <td class="a-datatable-datos-body-accion row-space">

                                    <!-- <p-checkbox [inputId]="row.key" name="group2" [value]="row.key"
                                        (onChange)="addTarifa($event, row, 'A', null)" [disabled]="!desagrupar" /> -->

                                    <input type="checkbox" [id]="row.key" name="groupServicios"
                                        [checked]="checkedServicios.includes(row.key)"
                                        (change)="onCheckServicioNative($event, row)" [disabled]="!desagrupar" />

                                    @if (row?.agrupado != true) {
                                    @if (!(['10', '11', '14', this.coordLog,
                                    this.gerentLog].includes(storage.get('rol')) && row.rol_usrcrea === '4')) {
                                    <p-button (onClick)="eliminarServicio(row, 'D')" icon="pi pi-trash"
                                        pTooltip="Eliminar"
                                        [disabled]="row.cons_codest !== null && row.cons_codest !== '001' && row.cons_codest !== '006'? true : (edicion || !desagrupar)">
                                    </p-button>
                                    }
                                    }
                                </td>
                                }
                                @else {
                                <td class="a-datatable-datos-body-accion row-space">
                                    <div class="leyenda-icon-container">
                                        <div class="leyenda-icon-table"
                                            [style.background]="colorLeyendasAgrupacion(row)">
                                        </div>
                                    </div>
                                </td>
                                }
                            </ng-template>

                        </app-datatable>
                    </div>
                    <!-- <div class="a-example-full-width-alterno-content">
                        <app-datatable [dataTable]="servicioslocales_detalleAgrupacion"
                            [btnDisabled]="!modovisualizar || !desagrupar || edicion" [hidden]="adicional === true"
                            [metadataTable]="metadataTableDetalleAgrupacion" [key]="'key'">
                            <ng-template #addHeaderStart>
                                <th class="header" *ngIf="modovisualizar">
                                    <div class="items-header">
                                        <span>Acción</span>
                                    </div>
                                </th>
                            </ng-template>
                            <ng-template #addBodyStart let-row="row">
                                <td class="a-datatable-datos-body-accion row-space" *ngIf="modovisualizar">
                                    <p-checkbox [inputId]="row.key" name="group2" [value]="row.key"
                                        (onChange)="addTarifa($event,row, 'D',null)" [disabled]="edicion" />
                                    <p-button (onClick)="eliminarServicio(row,'A')" icon="pi pi-trash"
                                        pTooltip="Eliminar" [disabled]="edicion || !desagrupar"></p-button>
                                </td>
                            </ng-template>
                        </app-datatable>
                    </div> -->
                </div>
            </div>
        </form>

    </p-accordionTab>
    }
</p-accordion>

<!-- <button mat-icon-button [matMenuTriggerFor]="menu2" class="boton_menu" *ngIf="!esVisualizar">
    <mat-icon>more_vert</mat-icon>
</button> -->

<button id="btnGuardarPrincipal" [disabled]="deshabilitarBtnGuardar || !modovisualizar" mat-icon-button
    (click)="operaciones_menu('Guardar',$event)" class="boton_menu" *ngIf="verBtnSave">
    <mat-icon>save</mat-icon>
</button>

<form [formGroup]="group_flotantes" class="inputs_top"
    *ngIf=" (esVisualizar == false || (esVisualizar == true && group_datosgenerales.get('estado')?.value == '009')) && group_datosgenerales.get('numero').value !=null">
    <p-floatlabel class="w-full md:w-full bold-floatlabel" variant="on">
        <input inputId="on_label" [ngClass]="{ readonly: true }" pInputText formControlName="ccotnumdoc_visualizacion"
            appendTo="body" class="w-full md:w-full" pSize="small" />
        <label for="on_label">N° OV</label>
    </p-floatlabel>

    <p-floatlabel class="w-full md:w-full bold-floatlabel" variant="on">
        <input inputId="on_label" [ngClass]="{ readonly: true }" pInputText formControlName="doovhbl_visualizacion"
            appendTo="body" class="w-full md:w-full" pSize="small" />
        <label for="on_label">{{nombre_bl}}</label>
    </p-floatlabel>
</form>

<mat-menu #menu2="matMenu">
    <button *ngFor="let item of list_menu" (click)="operaciones_menu(item.text)" class="items_menu"
        [disabled]="(item.text === 'Guardar' && deshabilitarBtnGuardar) || !modovisualizar">
        <div>
            <mat-icon>{{ item.icon }}</mat-icon>
        </div>
        <div>
            <span>{{ item.text }}</span>
        </div>
    </button>
</mat-menu>

<div style="height: 60px"></div>

<p-dialog *ngIf="popUpDocumentos" [(visible)]="popUpDocumentos" header="Ayuda Tipo de Documento" appendTo="body">
    <div class="a-w1-column">
        <div class="a-w1-row">
            <app-datatable [dataTable]="dt_documentos" [metadataTable]="mt_documentos">
            </app-datatable>
        </div>
        <div class="a-w1-row">
            <p-button label="Aceptar" (onClick)="aceptarPopUpDocumento()"></p-button>
            <p-button label="Cancelar" (onClick)="manejoPopUpDocumentos('C',0)"> </p-button>
        </div>
    </div>
</p-dialog>

<p-dialog *ngIf="popUpAuditoriaChangeControl" [(visible)]="popUpAuditoriaChangeControl"
    header="Resultado de la Auditoría - Orden de Venta Detalle Servicio" appendTo="body">
    <div class="a-w1-column">
        <div class="a-w1-row">
            <app-datatable [dataTable]="dt_auditoriaServChangeControl" [metadataTable]="mt_auditoriaServChangeControl"
                [customButtons]="custombAudiServChangeControl">
            </app-datatable>
        </div>
        <div class="a-w1-row">
            <p-button label="Aceptar" (onClick)="aceptarPopUpDocumento()"></p-button>
            <p-button label="Cancelar" (onClick)="manejoPopUpDocumentos('C',0)"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog header="Autorización" [(visible)]="visibleAuth" [style]="{width: '30vw',height: '45vh'}" appendTo="body"
    closeOnEscape="false">
    <div class="a-w1">
        <form [formGroup]="groupAuth">
            <div class="a-w1-row card flex justify-center">
                <div class="flex flex-wrap gap-4">
                    <div class="flex items-center gap-2">
                        <div *ngFor="let tipo of tipoAuth" class="field-checkbox">
                            <p-radiobutton [value]="tipo.key" formControlName="tipoauth" [inputId]="tipo.key"
                                (ngModelChange)="mostrarModAuth($event)" />
                            <label [for]="tipo.key" class="ml-2">{{ tipo.name }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;" *ngIf="!modoT">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <input inputId="on_label" pInputText formControlName="usuario" class="w-full md:w-56"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('usuario')?.invalid && (this.groupAuth.get('usuario')?.touched)}" />
                        <label for="on_label">Usuario</label>
                    </p-floatlabel>
                    <small *ngIf="this.groupAuth.get('usuario')?.invalid && (this.groupAuth.get('usuario')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;" *ngIf="!modoT">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-password formControlName="contrasenia" inputStyleClass="w-full" styleClass="w-full md:w-56"
                            class="w-full md:w-56" [feedback]="false" inputId="on_label"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('contrasenia')?.invalid && (this.groupAuth.get('contrasenia')?.touched)}"
                            [toggleMask]="true" />
                        <label for="on_label">Contraseña</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupAuth.get('contrasenia')?.invalid && (this.groupAuth.get('contrasenia')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;" *ngIf="modoT">
                <div class="a-w1">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
                        <p-floatlabel class="w-11 md:w-56" variant="on">
                            <input inputId="on_label" pInputText formControlName="token" class="w-11 md:w-56"
                                [disabled]="btnToken" [maxlength]="6"
                                [ngClass]="{'ng-invalid ng-dirty': this.groupAuth.get('token')?.invalid && (this.groupAuth.get('token')?.touched)}" />
                            <label for="on_label">Token</label>
                        </p-floatlabel>
                        <p-button icon="pi pi-key" label="Generar Token" *ngIf="btnToken"
                            (onClick)="GenerarTokenAuth()" />
                        <small *ngIf="!btnToken"
                            class="text-xs display: flex; flex-wrap: wrap; w-9; white-space: normal;">
                            {{mensajeIntento}}
                        </small>
                    </div>
                    <small *ngIf="this.groupAuth.get('token')?.invalid && (this.groupAuth.get('token')?.touched)"
                        class="text-red-600 text-xs display: flex; flex-wrap: wrap; w-9; white-space: normal;">
                        {{mensajeError}}
                    </small>
                </div>
            </div>
        </form>
    </div>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button label="Autorizar" (onClick)="AutorizarCambioVenta('A')"></p-button>
        <p-button label="No Autorizar" (onClick)="AutorizarCambioVenta('N')"></p-button>
    </div>
</p-dialog>

<p-dialog header="Prefacturación" [(visible)]="viewPoppupPrefacturacion" [style]="{width: '60vw',height: '55vh'}"
    appendTo="body" draggable="false" closeOnEscape="false" (onHide)="PrefacturarServicios('C')" [maximizable]="true">
    <app-prefacturacion *ngIf="viewPoppupPrefacturacion" (onProcesado)="manejoEventoPrefacturacion($event)"
        [data]="data_pf"></app-prefacturacion>
</p-dialog>
<p-dialog header="Cambio a Tarifa Real" [(visible)]="viewTarifarioCosto" [style]="{width: '70vw'}" appendTo="body">
    <app-datatable [dataTable]="dataTableTarifaServicioLogistico2"
        [metadataTable]="metadataTableTarifaServicioLogistico2" [key]="'key'" [filter]="true"
        [hidden]="dataTableTarifaServicioLogistico2.length === 0" (checkboxChange)="seleccionTarifa($event)"
        [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <app-datatable [dataTable]="dataTableTarifaAlmacen2" [metadataTable]="metadataTableTarifaAlmacen2" [key]="'key'"
        [hidden]="dataTableTarifaAlmacen2.length === 0" (checkboxChange)="seleccionTarifa($event)"
        [styleRow]="styleRowAlm" [filter]="true" [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <app-datatable [dataTable]="dataTableTransporte2" [metadataTable]="metadataTableTransporte2" [key]="'key'"
        [hidden]="dataTableTransporte2.length === 0" (checkboxChange)="seleccionTarifa($event)" [filter]="true"
        [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <app-datatable [dataTable]="dataTableAgeAduana2" [metadataTable]="metadataTableAgeAduana2" [key]="'key'"
        [hidden]="dataTableAgeAduana2.length === 0" (checkboxChange)="seleccionTarifa($event)" [filter]="true"
        [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <app-datatable [dataTable]="dataTableExtras2" [metadataTable]="metadataTableExtras2" [key]="'key'"
        [hidden]="dataTableExtras2.length === 0" (checkboxChange)="seleccionTarifa($event)" [filter]="true"
        [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <app-datatable [dataTable]="dataTableTc2" [metadataTable]="metadataTableTc2" [key]="'key'"
        [hidden]="dataTableTc2.length === 0" (checkboxChange)="seleccionTarifa($event)" [filter]="true"
        [scrollHeight]="'60vh'" [btnResetFiltros]="true" [caption]="true">
    </app-datatable>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button label="Seleccionar" (onClick)="CambiarTarifaDatadetalle('S')"></p-button>
        <p-button label="Cancelar" (onClick)="CambiarTarifaDatadetalle('C')"></p-button>
    </div>
</p-dialog>

<p-dialog header="Zonas" [(visible)]="visibleZonas" appendTo="body">
    <div class="a-example-full-width-alterno-content-row">

        <app-readonly-data-table [dataTable]="dtZonas" [metadataTable]="mtZonas" [key]="'ezon_codigo'"
            nombreListaHijos='detail' [style]="estilos" [filterGlobal]="true"
            [caption]="true"></app-readonly-data-table>

    </div>
</p-dialog>

<style>
    ::ng-deep p-select.readonly .p-select-trigger,
    ::ng-deep p-select.readonly .p-select-label {
        position: relative;
        pointer-events: none;
        opacity: 0.5;
        user-select: none;
        background-color: #f0f0f0;
    }

    .readonly {
        position: relative;
        pointer-events: none;
        opacity: 0.5;
        user-select: none;
        background-color: #f0f0f0;
    }

    .checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .radiobutton {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .checkbox>label {
        padding-left: 5px;
    }

    .radiobutton>label {
        padding-left: 5px;
    }

    .InputSwitch {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .InputSwitch>p-inputSwitch {
        margin-right: 5px;
    }

    p-tabView>p-tabPanel {
        width: 500px;
    }

    input {
        width: 100%;
    }

    :host ::ng-deep .p-select {
        width: 100%;
    }

    :host ::ng-deep .p-datepicker {
        width: 100%;
    }

    :host ::ng-deep .p-inputnumber {
        width: 100%;
    }

    :host ::ng-deep p-inputnumber,
    .p-inputnumber {
        width: 100%;
    }

    :host ::ng-deep .p-fieldset {
        padding: 0px !important;
    }

    :host ::ng-deep .p-fieldset-legend {
        padding: 0px !important;
        background-color: transparent;
        border: none;
        padding: 5px;
        margin-left: 10px;
    }

    :host ::ng-deep .p-tabview .p-tabview-panels {
        padding: 5px;
    }

    :host ::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
        padding: 7px;
    }

    :host ::ng-deep .p-inputtext-sm .p-inputtext {
        width: 100;
    }

    ::ng-deep .p-overlay {
        width: 100 !important;
    }
</style>